import { useEffect } from 'react';

const Landing = () => {
    useEffect(() => {
        let queryString = window.location.search;

        try {
            if (queryString) {
                if (queryString === "?s=r") {
                    queryString = queryString.replace("s=r", "utm_source=reddit");
                } else if (queryString === "?s=q") {
                    queryString = queryString.replace("s=q", "utm_source=quora");
                } else if (queryString === "?s=f") {
                    queryString = queryString.replace("s=f", "utm_source=facebook");
                }else if (queryString === "?s=g") {
                    queryString = queryString.replace("s=g", "utm_source=google");
                }
            }
        } catch (error) {
            console.log(error);
        }

        window.location.href = '/home.html' + queryString;
    }, []);

    return null;
};

export default Landing;
